module.exports = __webpack_public_path__ + "e560bdce3d72a2b56fdbed1782b15eaf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/komikatext/KOMTXT.svg
// module id = 223
// module chunks = 0